import React, { useEffect } from 'react';

import { usePageLoadEvent } from '../../utils/analytics/usePageLoadEvent';
import { TWO_FACTOR_ENROLLMENT_PROMPTED_KEY } from '../../utils/constants';

import { MlifeActivationContextProvider } from './MlifeActivationContext';
import { MlifeActivationStepper } from './MlifeActivationStepper';

export function MlifeActivationWrapper() {
  usePageLoadEvent('sign up', 'verify account');

  // Reset the '2fa_enrollment_prompted' flag so that a second user signing up in the same browser tab is still prompted for MFA enrollment
  useEffect(() => {
    sessionStorage.removeItem(TWO_FACTOR_ENROLLMENT_PROMPTED_KEY);
  }, []);

  return (
    <MlifeActivationContextProvider>
      <MlifeActivationStepper />
    </MlifeActivationContextProvider>
  );
}
